module.exports = __webpack_public_path__ + "img/Email-Success512.8761fa13.png";